export default "__VITE_ASSET__CRNZX5ov__"